import Vue from 'vue';
import { Popover, Loading, Dialog, Radio, RadioGroup, Checkbox, Table, TableColumn, Pagination, Link, Button, Input } from  'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/css/index_red.css';
import '@/styles/scss/elementUI.scss';

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// 设置语言
locale.use(lang)

Vue.prototype.$ELEMENT = { size: 'medium' };

Vue.use(Popover)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Link)
Vue.use(Button)
Vue.use(Input)